import { useMutation as defaultUseMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { canExtendTrial as _canExtendTrial } from "./canExtendTrial";
export const extendTrialMutation = gql `
  mutation upsells_extendTrialMutation(
    $accountId: ID!
    $reason: String!
    $shouldAutoUpgrade: Boolean
  ) {
    extendAccountTrial(
      id: $accountId
      reason: $reason
      shouldAutoUpgrade: $shouldAutoUpgrade
    ) {
      id
    }
  }
`;
export const useExtendTrial = ({ account, reason, shouldAutoUpgrade, useMutation, }) => {
    var _a;
    const _useMutation = useMutation || defaultUseMutation;
    const [extendTrial, { error: mutationError, loading: isLoadingMutation }] = _useMutation(extendTrialMutation, {
        variables: {
            accountId: account === null || account === void 0 ? void 0 : account.id,
            reason,
            shouldAutoUpgrade,
        },
    });
    return {
        canExtendTrial: account
            ? _canExtendTrial({
                currentPlanAmount: (_a = account === null || account === void 0 ? void 0 : account.plan) === null || _a === void 0 ? void 0 : _a.amount,
                enabledTrialExtensions: account === null || account === void 0 ? void 0 : account.enabledTrialExtensions,
                isTrialingCompanies: account === null || account === void 0 ? void 0 : account.isTrialingCompanies,
                isTrialingProfessional: account === null || account === void 0 ? void 0 : account.isTrialing,
                isTrialingTeams: account === null || account === void 0 ? void 0 : account.isTrialingTeams,
                reason: reason,
            })
            : false,
        error: mutationError,
        extendTrial,
        isLoading: isLoadingMutation,
    };
};

// @zapier/upsells@8.0.3 (1de7a616e)
